import { FormControl } from '@chakra-ui/react'
import { useFormContext } from 'react-hook-form'

import { FormLabel } from '../../components/FormLabel'
import { CheckboxStack } from '../../components/CheckboxStack'
import { CheckboxIconGroup } from '../../components/CheckboxIconGroup'
import { CheckboxIcon } from '../../components/CheckboxIcon'

export const InsuranceType = () => {
  const { control } = useFormContext()

  return (
    <FormControl>
      <FormLabel>Typ pojištění</FormLabel>

      <CheckboxIconGroup control={control} name="insuranceType">
        <CheckboxStack>
          <CheckboxIcon value="buildings" customIcon="buildings">
            Budovy
          </CheckboxIcon>
          <CheckboxIcon value="stock" customIcon="stock">
            Zásoby
          </CheckboxIcon>
          <CheckboxIcon customIcon="vehicle" value="vehicle">
            Stroje, elektronika a&nbsp;movité věci
          </CheckboxIcon>
          <CheckboxIcon customIcon="responsibility" value="responsibility">
            Odpovědnost
          </CheckboxIcon>
          <CheckboxIcon customIcon="interruptions" value="interruptions">
            Přerušení provozu
          </CheckboxIcon>
        </CheckboxStack>
      </CheckboxIconGroup>
    </FormControl>
  )
}
